// @see: https://github.com/sciactive/pnotify

/****** PNOTIFY - DEFAULTS ALERTS ******/

window.PNotify = require("@pnotify/core/dist/PNotify");

import {Stack, defaultModules} from "@pnotify/core/dist/PNotify";
import * as PNotifyAnimate from "@pnotify/animate";
import * as PNotifyBootstrap4 from "@pnotify/bootstrap4";
import * as PNotifyFontAwesome5Fix from "@pnotify/font-awesome5-fix";
import * as PNotifyFontAwesome5 from "@pnotify/font-awesome5";

defaultModules.set(PNotifyBootstrap4, {});
defaultModules.set(PNotifyFontAwesome5Fix, {});
defaultModules.set(PNotifyFontAwesome5, {});

const defaultStack = new Stack({
    dir1: 'up',
    dir2: 'left',
    firstpos1: 25,
    firstpos2: 25,
    spacing1: 36,
    spacing2: 36,
    push: 'bottom',
    context: document.body
});

/**
 * Show Alert Success by PNotify.
 *
 * @param      {string}  text    The text to show on body alert.
 */
window.pNotifySuccess = function (text) {
    window.notice = new PNotify.success({
        title: "<b>¡Éxito</b>",
        titleTrusted: true,
        text: text,
        textTrusted: true,
        delay: 1000,
        // Anclamos abajo a la derecha
        stack: defaultStack,
        sticker: false,
        icon: "fas fa-check-circle fa-lg",
    });
    notice.on("click", () => {
        notice.close();
    });
}

/**
 * Show Alert Warning by PNotify.
 *
 * @param      {string}  text    The text to show on body alert.
 */
window.pNotifyWarning = function (text) {
    //PNotify.removeAll();
    window.notice = new PNotify.notice({
        title: `<b>${trans('Attention!')}</b>`,
        titleTrusted: true,
        text: text,
        textTrusted: true,
        delay: 1000,
        // Anclamos abajo a la derecha
        stack: defaultStack,
        sticker: false,
        icon: "fas fa-exclamation-triangle fa-lg",
    });
    notice.on("click", () => {
        notice.close();
    });
}

/**
 * Show Alert Error by PNotify.
 *
 * @param      {string}  text    The text to show on body alert.
 */
window.pNotifyError = function (text) {
    window.notice = PNotify.error({
        title: `<b>${trans("¡Error!")}</b>`,
        titleTrusted: true,
        text: text,
        textTrusted: true,
        // Anclamos abajo a la derecha
        stack: defaultStack,
        hide: false,
        sticker: false,
        icon: "fas fa-exclamation-triangle fa-lg",
    });
    notice.on('click', () => {
        notice.close();
    });
}

/**
 * Show Alert No Connection Error by PNotify.
 */
window.pNotifyErrorConnection = function () {
    pNotifyError(trans("Problems connecting to the server."));
}

/* FIN: PNOTIFY - DEFAULTS ALERTS */
